@use '@/scss/underscore' as _;

.container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: _.unit(2);
  min-width: 540px;

  &.withSubmitActionBar {
    padding-bottom: 0;
  }

  >:not(:first-child) {
    margin-top: _.unit(4);
  }

  .fields {
    flex-grow: 1;

    > :not(:first-child) {
      margin-top: _.unit(4);
    }
  }
}
